<style lang="scss" scoped>
    .terms-wrapper {
        margin: 10px 0;
    }

    .terms-content {
        font-size: 12px;
        color: #8e8e8e;
    }
</style>


<template>
    <div class="terms-wrapper">
        <p class="terms-content">This form is protected by reCAPTCHA and the Google
        <a href="https://policies.google.com/privacy">Privacy Policy</a> and
        <a href="https://policies.google.com/terms">Terms of Service</a> apply.
        </p>
    </div>
</template>


<script>
    export default {
        name: "RecapchaTerms"
    };
</script>
